import { render, staticRenderFns } from "./ReportTables.vue?vue&type=template&id=ebef5482&scoped=true&"
import script from "./ReportTables.vue?vue&type=script&lang=js&"
export * from "./ReportTables.vue?vue&type=script&lang=js&"
import style0 from "./ReportTables.vue?vue&type=style&index=0&id=ebef5482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebef5482",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCol,VImg,VProgressCircular,VRow,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebef5482')) {
      api.createRecord('ebef5482', component.options)
    } else {
      api.reload('ebef5482', component.options)
    }
    module.hot.accept("./ReportTables.vue?vue&type=template&id=ebef5482&scoped=true&", function () {
      api.rerender('ebef5482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Report/ReportTables.vue"
export default component.exports